import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-grid-system';
import styled from 'styled-components';

import Footer from 'SharedComponents/footer';
import Tabs from 'SharedComponents/tabs';
import SelectSubscriptionPlan from 'SharedComponents/select-subscription';
import PromoCodePurchaseButton from 'SharedComponents/promo-code-purchase-button';

import styles from './index.css';

const PartnershipsWrapper = styled.section`${styles}`;


const Partnerships = () => {
  const navigate = useNavigate(); // Updated hook
  const [searchParams] = useSearchParams();

  //const authentication = useSelector((state) => state.authentication);

  const availableEmployerSubscriptionPlans = useSelector(state => 
    state.subscriptions.availSubscriptionPlans.filter(plan => plan.subscriptionSponsor === 'employer')
  );

  const selectedPlan = Array.isArray(availableEmployerSubscriptionPlans) 
  ? availableEmployerSubscriptionPlans.find(plan => typeof plan.subscriptionAmount === "number" && plan.subscriptionAmount > 0) 
  : null;
  
  const initialTab = searchParams.get("tab");
  console.log('partnerships - initialTab:', initialTab);

  const [activeTab, setActiveTab] = useState( initialTab || 
    ('employers'));

  useEffect(() => {

    const currentUrlTab = new URL(window.location).searchParams.get("tab");
    console.log('partnerships - useEffect - activeTab triggered with NEW activeTab: ', activeTab);
    console.log('partnerships - useEffect - activeTab triggered with OLD currentUrlTab: ', currentUrlTab);

    if (currentUrlTab !== activeTab) {
      console.log('partnerships - useEffect - activeTab EXECUTING to set url to activeTab: ', activeTab);
      const url = new URL(window.location);
      url.searchParams.set('tab', activeTab);
      window.history.replaceState({}, '', url);
    }


  }, [activeTab]);

  const onActiveTabChanged = (newActiveTab) => {
    console.log('*** onActiveTabChanged triggered with newActiveTab:', newActiveTab);
    setActiveTab(newActiveTab);
  };

  return (
    <PartnershipsWrapper>
      <div className="partnerships-content">
        <h2>Partner with Boost Your Super</h2>
        <Tabs
          activeTab={activeTab}
          onActiveTabChanged={onActiveTabChanged}
          tabs={[
          { label: 'Superfunds', value: 'superfunds' },
          { label: 'Employers', value: 'employers' },
          { label: 'Merchants', value: 'merchants' }, 
          { label: 'Financial Advisors', value: 'financial-advisors' },
          { label: 'Founders', value: 'founders' }
          ]}
         />
        <div className="partner-content-container">
          {
            activeTab === 'superfunds' ? (
              <div className="partner-container">
                <h1>Engage Your Members</h1>
                <p>Partner with us to provide more meaningful engagement with your members</p>
                <ul>
                  <li>Bring your brand to your members daily</li>
                  <li>Help your members learn and earn more super</li>
                </ul>
                <p>Contact us for a super member engagement pack at accounts@boostyoursuper.com.au</p>
              </div>
            ) : activeTab === 'employers' ? (
              <div className="partner-container">

                <Container fluid className="links-container" style={{ margin: 0, padding: 0, width: '100%' }}>
                  <Row style={{ margin: 0, padding: 0, width: '100%' }}>
                    <Col xl={6} lg={6} md={6} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                    <div className="acceptance-card">
                      <h2 className="title">Purchase Employee Subscription Plans</h2>
                      <SelectSubscriptionPlan
                        subscriptionFeaturesOn={true}
                        sponsorFilter={"employer"}
                      />
                      <PromoCodePurchaseButton/>
                    </div>

                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                    <div className="acceptance-card">
                      <h2>Employers - Boost Your Employee Benefits</h2>
                      <p>Empower your employees with a simple way to grow their superannuation towards further securing their financial future—all for just $4 a month per employee. With the Round-Ups program, employees can round up their everyday purchases to the nearest dollar, and that extra change goes directly into their super. </p>
                      <p>It’s a seamless way to help your staff build a stronger financial future, showing that you care about their long-term wellbeing. Plus, it’s an easy benefit to offer that adds real value to your employee benefits package.</p>
                      <ul>
                        <li><strong>Boost retention and engagement:</strong> Employees appreciate meaningful benefits that enhance their financial security.</li>
                        <li><strong>Cost-effective benefit:</strong> For a low monthly fee, offer employees a program that could significantly impact their super balance over time.</li>
                        <li><strong>Show your commitment:</strong> Demonstrates that your business is invested in employees' financial futures, boosting morale and loyalty.</li>
                        <li><strong>Effortless implementation:</strong> Easy to set up with minimal admin required, ensuring a hassle-free experience for your business.</li>
                        <li><strong>Attractive for recruitment:</strong> Stand out in the competitive job market by offering innovative perks that future-proof your employees.</li>
                      </ul>
                      <p>Contact us employergroup@boostyoursuper.com.au <a href="mailto:employergroup@boostyoursuper.com.au" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', fontWeight: 'bolder' }}>here</a>.</p>
                    </div>

                    </Col>
                  </Row>
                </Container>

              </div>
            ) : activeTab === 'merchants' ? (
              <div className="partner-container">
                <h2>Join our list of partner stores</h2>
                <p>Feature your store on our website by  joining one of our partner affiliate networks.</p>
                <p>You can join Commission Factory <a href="https://www.commissionfactory.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', fontWeight: 'bolder' }}>here</a>.</p>
              </div>
            ) : activeTab === 'financial-advisors' ? (
              <div className="partner-container">
                <h2>Support our Hacks 4 Your Super series</h2>
                <p>We work with financial advisors whom specialise in superannuation. Contact us about participating in our <span font="bold">Hacks 4 Your Super </span>email series where we cover tips and tricks that can help our users to retire with more.</p>
                <h2>Integrate our Round-Ups into client advice</h2>
                <p>We are getting more and more interest from financial advisors on how to use the service and integrate into client advice. Contact us for a free walk through.</p>
                <p>Contact us at <a href="mailto:accounts@boostyoursuper.com.au" target="_blank">accounts@boostyoursuper.com.au</a>.</p>
              </div>
            ) : (
              <div className="partner-container">
                <h2>Co-Founders: Have an idea to help Boost Super?</h2>
                <p>Boost Your Super is a start up and always looking for new ideas to help our users grow their super. If you have an idea you would like to try and are willing to consider a partnership then get in contact with us.</p>
                  <ul>
                    <li>We already have an audience that is interested in super and many of them are happy to test out new products.</li>
                    <li>We have a tech platform and developers ready to help.</li>
                  </ul>
                <p>Contact us at <a href="mailto:accounts@boostyoursuper.com.au" target="_blank">accounts@boostyoursuper.com.au</a>.</p>
              </div>
            )
          }
        </div>
      </div>
      <Footer />
    </PartnershipsWrapper>
  );
}

export default Partnerships;
